<template>
    <div class="zlNotes">
      <div class="note-list" v-loading="notesLoading">
        <template v-if="noteList && noteList.length">
					<div class="note_tab">
					  <p class="note_tab_p" v-for="(item,index) in tabList" :key="index" @click="activeThis(index)"
					     :class="{activeStyle:type === index}">
					    {{item}}
					  </p>
					</div>
          <div class="note-item" v-for="(item, index) in noteList" :key="index + 'noteList'">
            <div class="left_portrait">
            	<img src="/static/images/study/icon/teacher.png"/>
            </div>
            <div class="right_portrait">
            	<div class="top">
            		<span class="name">{{item.username}}</span>
            		<span class="time">{{item.date}}</span>
            		<span class="status" :style="handleStatus(item.noteType)">{{item.noteType}}</span>
            	</div>
            	<div class="content">
            		<div :class="{'total-introduce':item.showTotal,'detailed-introduce':!item.showTotal}">
            			<div class="intro-content" :title="item.content" ref="desc">
            				<p class="merchant-desc" v-html="item.content"></p>
            				<div class="unfold" @click="showTotalIntro(item)" v-if="item.showExchangeButton">
            					<p>{{item.exchangeButton ? '展开' : '收起'}}</p>
            				</div>
            			 </div>
            		</div>
            	</div>
            	<div class="bottom">
            		<div class="left">
            			<img src="/static/images/study/icon/zhangjie.png"/>
            			<span v-if="item.catalogName">{{item.catalogName}}</span>
            			<span v-else>全部章节</span>
            		</div>
            		<ul class="right">
            			<li class="dianzan" v-if="!item.isUserPraise" @click="assist(item.noteId)">
            				<div></div>
            				<span>{{item.notePraiseNumber}}</span>
            			</li>
            			<li class="y_dianzan" v-else @click="unassist(item.noteId)">
            				<div></div>
            				<span>{{item.notePraiseNumber}}</span>
            			</li>
            			<li class="pinglun" @click="getComment(item,index)">
            				<div></div>
            				<span>{{item.replyNumber}}</span>
            			</li>
            			<li class="note_editor" @click="editorNote(item)">
            				<div></div>
            			</li>
            			<li class="delete" @click="delNote(item.noteId)">
            				<div></div>
            			</li>
            		</ul>
            	</div>
            	<div class="commentCont" v-if="item.status == 1" v-loading="noteLoading">
            		<div class="comment1"></div>
            		<div class="comment2" >
            			<div class="comment2_cont">
            				<div class="pinglun_text">
              				<el-input type="textarea" resize="none" placeholder="请输入内容" v-model="discussionContent" maxlength="300" show-word-limit></el-input>
              				<div class="btn">
              					<el-button type="primary" :disabled="disabledBtn" @click="publish(item)">发表</el-button>
              				</div>
              			</div>
              			<el-divider v-if="commentList.length"></el-divider>
              			<div class="comment-item" v-for="(v,i) in item.commentList" :key="i">
              				<div class="commentContent">
              					{{v.replyContent}}
              				</div>
              				<div class="comment-bottom">
              					<div class="left">
              						<span>{{v.userName}}</span><i class="zhiwei" v-if="v.isTeacherReply">教师</i></span>
              						<span>{{v.date}}</span>
              					</div>
              					<div class="right" v-if="v.isDelete" @click="delComment(v.replyId,v.learnId)"></div>
              				</div>
              			</div>
            			</div>
            		</div>
            		<div class="comment3"></div>
            	</div>
            </div>
          </div>
        </template>
        <div v-else class="isEmpty">
          <el-empty :image-size="100" description=" ">
            <p>暂无内容,快来记一笔吧</p>
            <p>良好的笔记习惯有助于课堂吸收和课后复习</p>
          </el-empty>
        </div>
      </div>
      <div class="note-text">
        <editor v-model="noteCont" :toolMenus="editorMenus" height="200px" :onlyKey="noteFlag"></editor>
        <div class="bottombtn">
          <el-checkbox v-model="isOpen">公开</el-checkbox>
          <el-button size="mini" type="primary" v-if="noteId" @click="editorSaveNote()">保 存</el-button>
          <el-button size="mini" type="primary" v-else @click="addNote()" >保 存</el-button>
        </div>
      </div>
    </div>
</template>

<script>
  /**
   *  通用笔记组件。
   *    wjl 2022.8.16
   */
  import * as api from "@/api/noteApi";
  import editor from '../../components/wjlEditor/index.vue'
    export default {
      name: "zlNotes",
      components:{ editor },
      props:{
        query: {
          type: Object,
          default: ()=>{},
        }
      },
      data(){
        return {
          notesLoading: false,
					noteLoading: false,
          isOpen: false,
          noteCont: '',  // 笔记内容
					noteFlag: true,
          noteList: [],
          noteId: '',  // 修改某条笔记的Id
          editorMenus:[ // 富文本菜单栏
            "bold", // 加粗
            "underline", // 下划线
            "italic", // 斜体
            "strikeThrough", // 横穿线
            "foreColor", // 文字颜色
            "backColor", // 背景色
						"code",
            "image", // 图片
          ],
					pageTotal:{
					  page: 1,
					  pageSize: 2000,
					  total: 0,
					},
					type: 0,   // 0最新发表 1浏览数 2点赞数  3回复数
					tabList: ['最新发表', '点赞数'],
					isRecently: true,
					isPraise: false,
					discussionContent: '',
					disabledBtn:true,
					commentList:[],
        }
      },
      created(){
        this.noteLoading = true;
        this.getNoteList()
      },
			watch:{
				discussionContent(val){
					val ? this.disabledBtn = false : this.disabledBtn = true;
				},
			},
      methods:{
        // 获取笔记
        getNoteList(){
          let param = {
						status: '全部', //状态（全部，已公开，未公开）
						isRecently:this.isRecently, //最新发表true
						isPraise:this.isPraise, //点赞数true
						classId:this.query.classId, //班级id
						catalogId:this.query.catalogId, //目录id
						catalogName:this.query.catalogName, //目录名称
						courseId:this.query.courseId,
						pageNum:this.pageTotal.page,
						pageSize:this.pageTotal.pageSize
          }
          api.getMyNote(param).then(res=>{
            if(res.code == 0){
							let arr = []
							let list = res.data.list
							list.forEach(item=>{
								let obj = {
									status: 0,
									...item
								}
								arr.push(obj)
							})
              this.noteList = arr;
            }
          }).catch(error=> console.log(error)).finally(()=>this.notesLoading = false)
        },
        // 新增一条
        addNote(){
          let param = {
            content: this.noteCont,
            type: this.isOpen ? '0':'1',
            courseId: this.query.courseId,
            resourceId: this.query.id,
            classId: this.query.classId,
            catalogId: this.query.catalogId
          };
          this.notesLoading = true;
          api.addNote(param).then(res=>{
            if(res.code == 0){
              this.getNoteList();
              this.noteCont = '';
              this.isOpen = false;
							this.noteFlag = !this.noteFlag
							this.notesLoading = false
              this.$messageSuccess('添加笔记成功');
            }else{
              this.$messageError(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        },
				editorNote(param){
					this.noteCont = param.content
					this.noteId = param.noteId
					this.noteFlag = !this.noteFlag
					this.isOpen = param.noteType == '未公开'?false:true
				},
        // 修改一条
        editorSaveNote(){
          let param = {
            content: this.noteCont,
            type: this.isOpen ? '0':'1',
            id: this.noteId
          };
          this.notesLoading = true;
          api.editorNote(param).then(res=>{
            if(res.code == 0){
              this.getNoteList();
              this.noteCont = '';
              this.noteId = '';
							this.noteFlag = !this.noteFlag
              this.isOpen = false;
              this.$messageSuccess('修改笔记成功');
							this.notesLoading = false
            }else{
              this.$messageError(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        },
        // 删除笔记
        delNote(id){
          this.$confirm('删除该笔记将删除该笔记下的全部评论', '删除笔记', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.notesLoading = true;
            api.delNote(id).then(res=>{
              if(res.code == 0){
                this.getNoteList();
                this.$messageSuccess('删除成功');
              }
            }).catch(error=>{
              console.log(error);
            })

          }).catch(() => { });
        },
				activeThis(index) {
				  this.type = index;
					if(this.type == 0){
						this.isRecently = true
						this.isPraise = false
					}else{
						this.isRecently = false
						this.isPraise = true
					}
				  this.getNoteList();
				},
				// 笔记点赞
				assist(id){
					let param = {
						learnId:id,
						isAdd:true
					}
					api.likeIfNote(param).then(res=>{
						if(res.code == 0){
							this.getNoteList();
						}
					}).catch(error=>{
						console.log(error);
					})
				},
				// 取消点赞
				unassist(id){
					let param = {
						learnId:id,
						isAdd:false
					}
					api.likeIfNote(param).then(res=>{
						if(res.code == 0){
							this.getNoteList();
						}
					}).catch(error=>{
						console.log(error);
					})
				},
				// 点击评论获取信息
				getComment(obj,index){
					this.curId = index
					this.discussionContent = '';
					if(obj.status == 0){
						this.$set(obj,'status',1);
						this.noteLoading = true;
						this.getNoteReply(obj.noteId,obj.replyNumber,index);
					}else{
						this.$set(obj,'status',0);
					}
				},
				// 获取笔记评论
				getNoteReply(id,num,index){
					api.getNoteReply(id).then(res=>{
						console.log(res);
						if(res.code == 0){
							this.noteLoading = false;
							let list = res.data;
							let arr = [];
							if(list.length){
								list.forEach(item=>{
									let obj = {};
									obj.replyId = item.replyId;
									obj.learnId = id;
									obj.userName = item.userName;
									obj.date = item.date;
									obj.replyContent = item.replyContent;
									obj.isDelete = item.isDelete;
									obj.isTeacherReply = item.isTeacherReply;
									obj.num = num;
									arr.push(obj);
								})
							}
							// this.noteList[index].commentList.push(arr)
							this.noteList = this.noteList.map(item=>{
								return {...item,commentList:arr}
							})
							console.log(this.noteList[index])
						}
					}).catch(error=>{
						console.log(error);
					})
				},
				showTotalIntro(val) {
					this.$set(val,'showTotal',!val.showTotal)
					this.$set(val,'exchangeButton',!val.exchangeButton)
				},
				// 发表评论
				publish(param){
					if(!this.isNull(this.discussionContent)){
						let obj = {
				  		learnId:param.noteId,
				  		discussionContent:this.discussionContent,
				  		courseId:this.query.courseId,
				  		classId:this.query.classId
				  	}
						api.publishReply(obj).then(res=>{
				  		console.log(res);
				  		if(res.code == 0){
				  			this.noteLoading = true;
				  			this.getNoteReply(obj.learnId);
				  			this.$set(param,'replyNumber',param.replyNumber*1+1);
				  			this.discussionContent = '';
				  		}
				  	}).catch(error=>{
				  		console.log(error);
				  	})
					}else{
						this.$messageWarning('评论内容不能全为空或空格');
						return
					}
				},
				isNull(str){
				  if (str == "") return true;
				  var regu = "^[ ]+$";
				  var re = new RegExp(regu);
				  return re.test(str);
				},
				// 删除评论
				delComment(id,learnId){
					this.$tipsDialog(
						"提示",
						"确定删除该评论吗？",
						"",
						"el-icon-warning",
						"rgb(255, 178, 60)"
					).then(() => {
						api.delReply(learnId,id).then(res=>{
							console.log(res);
							if(res.code == 0){
								this.$messageSuccess('删除成功');
								this.noteLoading = true;
								this.getNoteReply(learnId);
							}
						}).catch(error=>{
							console.log(res);
						})
					}).catch(() => {
	//        this.$message({
	//          type: 'info',
	//          message: '已取消删除'
	//        });
					});
				},
				// 处理状态颜色
				handleStatus(type){
					let styleColor = {};
					switch (type) {
						case '已公开':
				  		styleColor = {
				  			border:'1px solid rgba(83,151,247,1)',
				    		color: '#5397F7'
				  		}
						break;
						case '未公开':
				  		styleColor = {
				  			border:'1px solid rgba(255,178,60,1)',
				    		color: '#FFB23C'
				  		}
						break;
					}
					return styleColor
				},
      }
    }
</script>

<style scoped lang="scss">
.zlNotes{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .note-list{
    flex: 1;
		overflow: auto;
		margin: 10px;
    .note-item{
			display: flex;
			justify-content: flex-start;
			min-height: 106px;
			border:1px solid rgba(230,230,230,1);
			border-radius:4px;
			padding: 16px 24px;
			margin-bottom:16px;
			.left_portrait {
				width: 40px;
				height: 100%;
				img {
					display: inline-block;
					width: 40px;
					height: 40px;
				}
			}
			.right_portrait {
				flex: 1;
				.top {
					height: 40px;
					line-height: 40px;
					margin-left: 10px;
					.name {
						font-size: 14px;
					}
					.time {
						color: #999999;
						font-size: 12px;
						padding: 0 40px;
					}
					.status {
						display: inline-block;
						width:48px;
						height:18px;
						line-height: 18px;
						text-align: center;
						opacity:1;
						border-radius:2px;
						font-size: 12px;
					}
				}
				.content {
					margin-left: 10px;
					font-size: 14px;
					min-height: 40px;
					padding: 10px 0;
					position: relative;
					width: 95%;
					.total-introduce{
						height: auto;
						overflow: hidden;
						font-size: 14px;
						color: #666;
						.intro-content{
							.merchant-desc{
								width: 100%;
								line-height: 20px;
							}
						}
						.unfold{
							display: block;
							float: right;
							width: 80px;
							height: 40px;
							z-index: 8;
							text-align: center;
							cursor: pointer;
							p{
								margin: 0;
								line-height: 20px;
								color: #0098ff;
							}
						 }
					}
					.detailed-introduce{
						font-size: 14px;
						color: #666;
						position: relative;
						overflow: hidden;
						.intro-content{
							max-height: 60px;
							line-height: 20px;
							word-wrap: break-word;
							word-break: break-all;
							background-color: #fff;
							color: #fff;
							overflow: hidden;
							.merchant-desc{
								width: 100%;
								line-height: 20px;
							}
							&::after,
							&::before{
								content: attr(title);
								position: absolute;
								left: 0;
								top: 0;
								width: 100%;
								color: #666;
							}
							&::before{
								display: block;
								overflow: hidden;
								z-index: 1;
								max-height: 80px;
								background: #FFF;
							}
							&::after{
								display: -webkit-box;
								-webkit-box-orient: vertical;
								height: 40px;
								// 截取行数
								-webkit-line-clamp: 2;
								text-overflow: ellipsis;
								box-sizing: border-box;
								// 行首缩进字符数，值为[(截取行数-1)*尾部留空字符数]
								text-indent: -6em;
								// 尾部留空字符数
								padding-right: 3em;
							}
							.unfold {
								z-index: 8;
								outline: 0;
								position: absolute;
								right: 8px;
								bottom: 0;
								text-align: center;
								background-color: #fff;
								cursor: pointer;
								p {
									margin: 0;
									color: #0098ff;
								}
							}
						}
					}
				}
				.bottom {
					margin-left: 10px;
					display: flex;
					justify-content: space-between;
					img {
						display: inline-block;
						width: 14px;
						height: 14px;
					}
					span {
						font-size: 12px;
						color: #999999;
					}
					.left {
						display: flex;
						justify-content: space-between;
						align-items: center;
						span {
							display: inline-block;
							padding: 0 4px;
						}
					}
					.right {
						float: right;
						li {
							float: left;
							display: flex;
							align-items: center;
							justify-content: space-between;
							padding: 0 20px;
							height: 14px;
							border-right: 1px solid #E6E6E6;
							cursor: pointer;
							div {
								width: 14px;
								height: 14px;
							}
						}
						li:last-child {
							border: 0;
						}
						.dianzan {
							div {
								background: url(/static/images/study/icon/dianzan_hv.png) no-repeat;
								background-size: cover;
								margin-right: 6px;
							}
							&:hover {
								div {
									background: url(/static/images/study/icon/dianzan.png) no-repeat;
									background-size: cover;
									margin-right: 6px;
								}
							}
						}
						.y_dianzan {
							div {
								background: url(/static/images/study/icon/dianzan.png) no-repeat;
								background-size: cover;
								margin-right: 6px;
							}
						}
						.pinglun {
							div {
								background: url(/static/images/study/icon/pinglun_hv.png) no-repeat;
								background-size: cover;
								margin-right: 6px;
							}
							&:hover {
								div {
									background: url(/static/images/study/icon/pinglun.png) no-repeat;
									background-size: cover;
									margin-right: 6px;
								}
							}
						}
						.note_editor {
							div {
								background: url(/static/images/study/icon/bianji_hv.png) no-repeat;
								background-size: cover;
							}
							&:hover {
								div {
									background: url(/static/images/study/icon/bianji.png) no-repeat;
									background-size: cover;
								}
							}
						}
						.delete {
							div {
								background: url(/static/images/study/icon/shanchu_hv.png) no-repeat;
								background-size: cover;
							}
							&:hover {
								div {
									background: url(/static/images/study/icon/shanchu.png) no-repeat;
									background-size: cover;
								}
							}
						}
					}
				}
				.commentCont {
					position: relative;
					.comment1 {
						width: 0px;
						height:0px;
						border: 8px transparent solid;
						border-bottom-color: rgba(230,230,230,1);
						margin-left: 472px;
						position: absolute;
						top: -15px;
						right: 135px;
					}
					.comment2 {
						background: rgba(244,244,244,1);
						border: 1px rgba(230,230,230,1) solid;
						/*min-height: 105px;*/
						/*max-height: 396px;*/
						height: 396px;
						border-radius: 4px;
						margin-top: 10px;
						padding: 16px;
						overflow: auto;
						.noComment {
							text-align: center;
							img{
								width: 100px;
								margin-top: 20px;
							}
							p{
								font-size:14px;
								font-weight:400;
								color:rgba(153,153,153,1);
								margin-top: 16px;
							}
						}
						.pinglun_text {
							/deep/ .el-textarea__inner {
								height: 64px;
							}
							.el-button--primary.is-disabled {
								background-color: #E6E6E6;
								border-color: #E6E6E6;
								color: #999999;
							}
							.el-button {
								padding: 8px 23px;
								font-size: 12px;
							}
							.btn {
								margin-top: 12px;
								text-align: right;
							}
						}
						.el-divider--horizontal {
							margin: 16px 0;
						}
						.comment-item {
							padding-bottom: 16px;
							border-bottom: 1px solid #DCDFE6;
							.commentContent {
								padding: 14px 0;
							}
							.comment-bottom {
								display: flex;
								justify-content: space-between;
								align-items: center;
								.left {
									min-width: 200px;
									display: flex;
									justify-content: space-between;
									align-items: center;
									span {
										color: #999999;
									}
									.zhiwei {
										display: inline-block;
										width:34px;
										height:18px;
										text-align: center;
										line-height: 18px;
										background:rgba(232,242,255,1);
										opacity:1;
										border-radius:2px;
										font-size: 12px;
										color: #5397F7;
										margin: 0 13px;
										font-style: normal;
									}
								}
								.right {
									width: 14px;
									height: 14px;
									background: url(/static/images/study/icon/shanchu_hv.png) no-repeat;
									background-size: cover;
									cursor: pointer;
									&:hover {
										background: url(/static/images/study/icon/shanchu.png) no-repeat;
										background-size: cover;
									}
								}
							}
						}
					}
					.comment3 {
						width: 0px;
						height:0px;
						border: 9px transparent solid;
						border-bottom-color: rgba(244,244,244,1);
						position: absolute;
						top: -15px;
						right: 134px;
					}
				}
			}
    }
    .isEmpty{
      font-size: 12px;
      text-align: center;
      color: #cccccc;
      margin-top: 40%;
      p{
        margin-bottom: 10px;
      }
    }
		.note_tab {
		  display: flex;
		  align-items: center;
		  font-size: 12px;
		  margin-bottom: 10px;
		
		  .note_tab_p {
		    position: relative;
		    text-align: center;
		    cursor: pointer;
		    padding: 5px 17px;
		    color: #999999;
		  }
		
		  .activeStyle {
		    background: rgba(83, 151, 247, 1);
		    border-radius: 16px;
		    color: #fff;
		  }
		}
  }
  .note-text{
    padding: 10px;
		margin-bottom: 36px;
    .bottombtn{
      padding-top: 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 1001;
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/views/component/zlNotes.vue